import {
  Skeleton,
  Box,
  Flex,
  Heading,
  Button,
  useToast,
} from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { utils as commonUtils } from '@finley-technologies/common';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { errorToastConfig } from 'packages/common-frontend/constants';
import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';
import { FiArrowLeft } from 'react-icons/fi';

export const CreditAgreementsViewTemplate = ({
  children,
  disableSelectors,
}: {
  children: React.ReactNode;
  disableSelectors: boolean;
}) => {
  const toast = useToast();
  const navigate = useNavigate();

  const { data: userData } = useGetUserQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = commonUtils.EnvUtils.isProduction()
        ? 'An unexpected error occurred. Please contact Finley for support.'
        : err.message;
      toast(errorToastConfig);
    },
  });

  if (!userData || !userData.user) {
    return <Skeleton data-testid="loading-reports-view" height="600px" />;
  }

  const { organizationId } = userData.user;

  return (
    <Box>
      <Flex justify="space-between" width="100%">
        <Heading marginBottom="70px" display="inline-block">
          Credit Agreement Configuration
        </Heading>
        <Box>
          <CreditFacilitySelect
            organizationId={organizationId}
            isDisabled={disableSelectors}
          />
          {disableSelectors && (
            <Flex justify="flex-end" alignItems="center" mt="10px" mb="10px">
              <Button
                onClick={() => navigate(-1)}
                marginLeft={3}
                rightIcon={<FiArrowLeft />}
                aria-label="back"
              >
                Back
              </Button>
            </Flex>
          )}
        </Box>
      </Flex>
      {children}
    </Box>
  );
};
